import { TotalResultsCount } from '@app/core/components/TotalResultsCount';
import { CopyUrlButton } from '@app/core/list-view/actions/CopyUrlButton';
import { Box } from '@mui/material';
import { useReportCtx } from '../../../report-ctx';
import { DownloadReportBtnRhf } from './DownloadReportBtnRhf';
import { ResetReportBtnRhf } from './ResetReportBtnRhf';
import { VisualizeReportBtnRhf } from './VisualizeReportBtnRhf';

/**
 * Report actions: Visualize on the left (with result count when result has total); Download, Reset, copy URL on the right.
 */
export const ReportActionsRhf = () => {
  const ctx = useReportCtx();

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <VisualizeReportBtnRhf />
        <TotalResultsCount count={ctx.resultCount} isLoading={ctx.isLoading} />
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <ResetReportBtnRhf />
        <CopyUrlButton />
        {ctx.allowDownload && <DownloadReportBtnRhf />}
      </Box>
    </Box>
  );
};
